import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wallet, Ticket, Clock, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { sr } from "../../lib/sr";

const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
const daysLeft = (iso) => { if (!iso) return null; const d = Math.ceil((new Date(iso) - new Date()) / 86400000); return d; };

export default function Credits() {
  const [w, setW] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => { sr.creditWallet().then(setW).catch(() => toast.error("Could not load credits")).finally(() => setLoading(false)); }, []);

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }} data-testid="credit-wallet">
      <div className="sr-eyebrow">Billing</div>
      <h1 style={{ fontSize: 26, margin: "4px 0 0", display: "flex", alignItems: "center", gap: 10 }}><Wallet size={22} /> SmartReach Credits</h1>
      {loading && <p className="sr-muted"><Loader2 className="sr-spin" size={16} /> Loading…</p>}
      {w && (
        <>
          <div className="sr-card" style={{ marginTop: 18, padding: 22, background: "#0A121C", color: "#fff" }} data-testid="credit-available">
            <div style={{ color: "#93a1b3", fontSize: 13 }}>Available credit</div>
            <div style={{ fontSize: 44, fontWeight: 800, color: "#F2A33D" }}>{money(w.available)}</div>
            {w.held > 0 && <div style={{ color: "#93a1b3", fontSize: 13 }}>{money(w.held)} held for pending campaigns</div>}
            <button className="sr-btn sr-btn-primary" style={{ marginTop: 12 }} onClick={() => nav("/app/campaigns/new")} data-testid="credit-build-btn">Build a campaign</button>
          </div>

          {!w.credits?.length && !w.coupons?.length && (
            <div className="sr-card" style={{ marginTop: 16, padding: 24, textAlign: "center", color: "#888" }} data-testid="credit-empty">
              No SmartReach credits yet. When you receive a credit or coupon, it appears here.
            </div>
          )}

          {w.credits?.length > 0 && (
            <div style={{ marginTop: 20 }}>
              <div className="sr-eyebrow" style={{ marginBottom: 10 }}>Credits</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 12 }}>
                {w.credits.map((c) => {
                  const dl = daysLeft(c.expires_at);
                  return (
                    <div key={c.id} className="sr-card" style={{ padding: 16 }} data-testid={`credit-card-${c.id}`}>
                      <div style={{ fontWeight: 700 }}>{c.name}</div>
                      <div style={{ fontSize: 26, fontWeight: 800, color: "var(--navy,#0A121C)" }}>{money(c.available)}</div>
                      <div className="sr-muted" style={{ fontSize: 12 }}>of {money(c.initial)} · <span className="sr-badge">{c.status}</span></div>
                      {c.minimum_spend > 0 && <div className="sr-muted" style={{ fontSize: 12 }}>Min spend {money(c.minimum_spend)}</div>}
                      {c.expires_at && <div style={{ fontSize: 12, color: dl != null && dl <= 14 ? "#c0392b" : "#888", marginTop: 4 }}><Clock size={11} /> {dl != null ? `Expires in ${dl} days` : ""}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {w.coupons?.length > 0 && (
            <div style={{ marginTop: 20 }}>
              <div className="sr-eyebrow" style={{ marginBottom: 10 }}>Coupons</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 12 }}>
                {w.coupons.map((c) => (
                  <div key={c.claim_id} className="sr-card" style={{ padding: 16 }} data-testid={`coupon-card-${c.claim_id}`}>
                    <div style={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}><Ticket size={15} /> {c.name}</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: "var(--navy,#0A121C)" }}>{c.display}</div>
                    {c.max_discount && <div className="sr-muted" style={{ fontSize: 12 }}>Max {money(c.max_discount)}</div>}
                    {c.minimum_spend > 0 && <div className="sr-muted" style={{ fontSize: 12 }}>Min spend {money(c.minimum_spend)}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
          <p className="sr-muted" style={{ fontSize: 11, marginTop: 20 }}>SmartReach promotional credit has no cash value and may only be used toward eligible SmartReach products or services according to the promotion terms.</p>
        </>
      )}
    </div>
  );
}
